/** A multiselect field travels as a comma-joined string of option values ('' = none selected). */
export const splitSelection = (value: string): string[] => (value === '' ? [] : value.split(','));
export const joinSelection = (values: string[]): string => values.join(',');
